import { render } from "./P2PClient.vue?vue&type=template&id=36c21f46&scoped=true"
import script from "./P2PClient.vue?vue&type=script&lang=js"
export * from "./P2PClient.vue?vue&type=script&lang=js"

import "./P2PClient.vue?vue&type=style&index=0&id=36c21f46&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c21f46"]])

export default __exports__